<section class="page-hero page-hero-contact" aria-labelledby="contact-page-title">
  <div>
    <p class="eyebrow">Contact us</p>
    <h1 id="contact-page-title">Talk to Pavillion about your next property.</h1>
  </div>
  <p>
    Book a viewing, ask about availability, or request the current payment plan for a development.
  </p>
</section>

<section class="section contact-page" aria-label="Contact Pavillion Properties">
  <div class="contact-cards">
    <article>
      <span>01</span>
      <h2>Sales office</h2>
      <p>Nairobi, Kenya</p>
    </article>
    <article>
      <span>02</span>
      <h2>Call</h2>
      <a href="tel:+254700000000">+254 700 000 000</a>
    </article>
    <article>
      <span>03</span>
      <h2>Email</h2>
      <a href="mailto:info@pavillionproperties.co.ke">info@pavillionproperties.co.ke</a>
    </article>
  </div>

  <form class="contact-form inquiry-form" (ngSubmit)="inquirySent.emit()">
    <div class="form-heading">
      <p class="section-kicker"><span></span>Message us</p>
      <h2>Send a property inquiry</h2>
    </div>
    <label>
      Full name
      <input
        name="contactName"
        type="text"
        required
        [ngModel]="inquiry.name"
        (ngModelChange)="update('name', $event)"
      />
    </label>
    <label>
      Phone number
      <input
        name="contactPhone"
        type="tel"
        required
        [ngModel]="inquiry.phone"
        (ngModelChange)="update('phone', $event)"
      />
    </label>
    <label>
      Email
      <input
        name="contactEmail"
        type="email"
        [ngModel]="inquiry.email"
        (ngModelChange)="update('email', $event)"
      />
    </label>
    <label>
      Property of interest
      <select
        name="contactProperty"
        [ngModel]="inquiry.property"
        (ngModelChange)="update('property', $event)"
      >
        <option value="">General inquiry</option>
        @for (project of projects; track project.slug) {
          <option [value]="project.name">{{ project.name }}</option>
        }
      </select>
    </label>
    <label class="full-field">
      Message
      <textarea
        name="contactMessage"
        rows="5"
        required
        [ngModel]="inquiry.message"
        (ngModelChange)="update('message', $event)"
      ></textarea>
    </label>
    <button class="primary-button dark-button" type="submit" [disabled]="messageSending">
      {{ messageSending ? 'Sending...' : 'Send message' }}
    </button>
    @if (messageSent) {
      <p class="form-note">Thanks. Your inquiry has been sent.</p>
    }
    @if (messageError) {
      <p class="form-error">We could not send your inquiry. Please try again.</p>
    }
  </form>
</section>
